import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";
import TemplateCreateContent from "../../../components/Pages/Templates/Create";
import TemplateViewContent from "../../../components/Pages/Templates/View";

const { displayName } = config;

export default function TemplateView(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Template View`;
  }, []);

  return (
    <Layout>
      <TemplateViewContent />
    </Layout>
  );
}
